import { render, staticRenderFns } from "./ActiveOrg.vue?vue&type=template&id=a04987ca&scoped=true&"
import script from "./ActiveOrg.vue?vue&type=script&lang=js&"
export * from "./ActiveOrg.vue?vue&type=script&lang=js&"
import style0 from "./ActiveOrg.vue?vue&type=style&index=0&id=a04987ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04987ca",
  null
  
)

export default component.exports